export default class KeyboardService {
  constructor($document, $rootScope) {
    'ngInject';

    this._globalHandler = (e) => {
      if (!/^(INPUT|TEXTAREA)$/.test(e.target?.tagName)) {
        this._executeHandlers(e);
        if (!$rootScope.$$phase) {
          $rootScope.$apply();
        }
      }
    };

    $document.on('keydown', this._globalHandler);

    this.KEYS = {
      BACKSPACE: 8,
      ENTER: 13,
      ESC: 27,
      ARROW_LEFT: 37,
      ARROW_UP: 38,
      ARROW_RIGHT: 39,
      ARROW_DOWN: 40,
      T: 84,
      P: 112,
    };

    let keyCode;

    // 0-9
    for (keyCode = 48; keyCode <= 57; keyCode++) {
      this.KEYS[String.fromCharCode(keyCode).toUpperCase()] = keyCode;
    }

    // a-z
    for (keyCode = 65; keyCode <= 90; keyCode++) {
      this.KEYS[String.fromCharCode(keyCode).toUpperCase()] = keyCode;
    }

    this._handlersMap = new Map();
  }

  _executeHandlers(e) {
    (this._handlersMap.get(e.keyCode) || []).forEach((h) => h(e));
  }

  on(keyCode, handler) {
    let handlers = this._handlersMap.get(keyCode);
    if (!handlers) {
      handlers = [];
      this._handlersMap.set(keyCode, handlers);
    }

    handlers.push(handler);

    return () => {
      const index = handlers.indexOf(handler);

      if (index >= 0) {
        handlers.splice(index, 1);
      }
    };
  }
}
